import { Box, Grid, Icon, Popover, Tooltip } from '@mui/material'
import { isUndefined } from 'lodash'
import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'
import useBoolean from 'utils/customHook/useBoolean'
import { actionIconStyle } from 'components/ActionUtil'

const Dropdown = ({
    icon,
    tooltip = '',
    listItem = [],
}) => {
    const {
        value: isOpen,
        setTrue: open,
        setFalse: close,
    } = useBoolean(false)

    const [anchorEl, setAnchorEl] = useState()

    const iconAction = useMemo(() => {
        if (isUndefined(icon)) {
            return isOpen ? 'arrow_drop_up' : 'arrow_drop_down'
        }
        return icon
    }, [icon, isOpen])

    const id = open ? 'simple-popper' : undefined

    return (
        <>
            <Tooltip id={'dropdown_navbar'} title={tooltip}>
                <Box px={2}>
                    <Icon
                        id={id}
                        onClick={e => {
                            open()
                            setAnchorEl(e.currentTarget)
                        }}
                        sx={{ ...actionIconStyle }}
                    >
                        {iconAction}
                    </Icon>
                </Box>
            </Tooltip>
            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                onClose={close}
            >
                {listItem.map((item, i) => (
                    <Grid
                        key={i}
                        container
                        sx={{
                            width: 400,
                            padding: '10',
                            cursor: 'pointer', '&:hover': {
                                backgroundColor: '#eee',
                            },
                            borderBottom: i < listItem.length - 1 ? '1px solid #eee' : undefined,
                        }}
                        onClick={item.onClick}
                        alignItems='center'
                        spacing={1}
                    >
                        <Grid size='auto'>
                            <Icon>{item.icon}</Icon>
                        </Grid>
                        <Grid size='grow'>
                            <h6>{item.label}</h6>
                        </Grid>
                    </Grid>
                ))}
            </Popover>
        </>
    )
}

Dropdown.propTypes = {
    icon: PropTypes.string,
    tooltip: PropTypes.string,
    listItem: PropTypes.arrayOf(PropTypes.shape({
        onClick: PropTypes.func,
        icon: PropTypes.string,
        label: PropTypes.string,
    })),
}

export default Dropdown
